import '@snackbar/core/dist/snackbar.css';
import { Notes, themes } from 'mdx-deck';
import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { vsDark } from "@code-surfer/themes";
import Highlighter from 'react-syntax-highlighter';
import SearchPreviewer from "../../../../notes/src/previewers/search";
import DefaultPreviewer from "../../../../notes/src/previewers/default";
import * as React from 'react';
export default {
  Notes,
  themes,
  CodeSurfer,
  CodeSurferColumns,
  Step,
  vsDark,
  Highlighter,
  SearchPreviewer,
  DefaultPreviewer,
  React
};